import { ChoiceDashboardFilters, ChoiceRowsRequest } from "../../../domain/entities/ChoiceDashboard";
import { maskChoiceCsv, maskChoicePayload, maskChoiceRowsPage, unmaskChoiceFilters } from "../../utils/choicePrivacy";
import { isMaskedHere, maskStudentDetail } from "../../utils/dataPrivacyMasker";
import { Dispatch } from "redux";
import Campaign, { TargetAudience } from "../../../domain/entities/Campaign";
import DocumentTemplate from "../../../domain/entities/DocumentTemplate";
import Message from "../../../domain/entities/Message";
import Organization from "../../../domain/entities/Organization";
import Package from "../../../domain/entities/Package";
import SelectRouting from "../../../domain/entities/SelectRouting";
import SignatoryGroup from "../../../domain/entities/SignatoryGroup";
import Student from "../../../domain/entities/Student";
import User from "../../../domain/entities/User";
import RequestorInteractor from "../../../domain/interactors/RequestorInteractor";
import { ZoneFilter } from "../../components/pages/ui-utils/zoneFilterTypes";
import { SendDocFormInputs } from "../../components/widgets/SendIndvDocumentForm";
import { RootState } from "../reducers";

export enum ActionTypes {
  CAMPAIGN_LOAD_PROCESSING = "@requestor/CAMPAIGN_LOAD_PROCESSING",
  CAMPAIGN_LOAD_COMPLETE = "@requestor/CAMPAIGN_LOAD_COMPLETE",
  CAMPAIGN_LOAD_ERROR = "@requestor/CAMPAIGN_LOAD_ERROR",
  CAMPAIGNS_RESTORE_STATES = "@requestor/CAMPAIGNS_RESTORE_STATES",
  CAMPAIGN_CLEAN_VALUE = "@requestor/CAMPAIGN_CLEAN_VALUE",
  CAMPAIGNS_CLEAN_VALUE = "@requestor/CAMPAIGNS_CLEAN_VALUE",
  CAMPAIGN_SAVE_PROCESSING = "@requestor/CAMPAIGN_SAVE_PROCESSING",
  CAMPAIGN_SAVE_COMPLETE = "@requestor/CAMPAIGN_SAVE_COMPLETE",
  CAMPAIGN_SAVE_ERROR = "@requestor/CAMPAIGN_SAVE_ERROR",
  CAMPAIGN_SAVE_SEND_PROCESSING = "@requestor/CAMPAIGN_SAVE_SEND_PROCESSING",
  CAMPAIGN_SAVE_SEND_COMPLETE = "@requestor/CAMPAIGN_SAVE_SEND_COMPLETE",
  CAMPAIGN_SAVE_SEND_ERROR = "@requestor/CAMPAIGN_SAVE_SEND_ERROR",
  CAMPAIGNS_LOAD_PROCESSING = "@requestor/CAMPAIGNS_LOAD_PROCESSING",
  CAMPAIGNS_LOAD_COMPLETE = "@requestor/CAMPAIGNS_LOAD_COMPLETE",
  CAMPAIGNS_LOAD_ERROR = "@requestor/CAMPAIGNS_LOAD_ERROR",
  CAMPAIGN_DELETE_PROCESSING = "@requestor/CAMPAIGN_DELETE_PROCESSING",
  CAMPAIGN_DELETE_COMPLETE = "@requestor/CAMPAIGN_DELETE_COMPLETE",
  CAMPAIGN_DELETE_ERROR = "@requestor/CAMPAIGN_DELETE_ERROR",
  CAMPAIGN_LOCAL_DELETE = "@requestor/CAMPAIGN_LOCAL_DELETE",
  CAMPAIGN_SEND_PROCESSING = "@requestor/CAMPAIGN_SEND_PROCESSING",
  CAMPAIGN_SEND_COMPLETE = "@requestor/CAMPAIGN_SEND_COMPLETE",
  CAMPAIGN_SEND_ERROR = "@requestor/CAMPAIGN_SEND_ERROR",
  CAMPAIGN_SEND_INDIVIDUAL_PROCESSING = "@requestor/CAMPAIGN_SEND_INDIVIDUAL_PROCESSING",
  CAMPAIGN_SEND_INDIVIDUAL_COMPLETE = "@requestor/CAMPAIGN_SEND_INDIVIDUAL_COMPLETE",
  CAMPAIGN_SEND_INDIVIDUAL_ERROR = "@requestor/CAMPAIGN_SEND_INDIVIDUAL_ERROR",
  CAMPAIGNS_PAGINATION_LOAD_PROCESSING = "@requestor/CAMPAIGNS_PAGINATION_LOAD_PROCESSING",
  CAMPAIGNS_PAGINATION_LOAD_COMPLETE = "@requestor/CAMPAIGNS_PAGINATION_LOAD_COMPLETE",
  CAMPAIGNS_PAGINATION_LOAD_ERROR = "@requestor/CAMPAIGNS_PAGINATION_LOAD_ERROR",
  CAMPAIGNS_COUNT_LOAD_COMPLETE = "@requestor/CAMPAIGNS_COUNT_LOAD_COMPLETE",
  CAMPAIGNS_COUNT_LOAD_ERROR = "@requestor/CAMPAIGNS_COUNT_LOAD_ERROR",
  CAMPAIGNS_COUNT_LOAD_PROCESSING = "@requestor/CAMPAIGNS_COUNT_LOAD_PROCESSING",
  CAMPAIGNS_COUNT_CLEAN = "@requestor/CAMPAIGNS_COUNT_CLEAN",
  CLEAR_DOCUMENT_STAFF = "@requestor/CLEAR_DOCUMENT_STAFF",
  DOCUMENT_STAFF_PROCESS_PROCESSING = "@requestor/DOCUMENT_STAFF_PROCESS_PROCESSING",
  DOCUMENT_STAFF_PROCESS_COMPLETE = "@requestor/DOCUMENT_STAFF_PROCESS_COMPLETE",
  DOCUMENT_STAFF_PROCESS_ERROR = "@requestor/DOCUMENT_STAFF_PROCESS_ERROR",
  DOCUMENTTEMPLATE_SAVE_PROCESSING = "@requestor/DOCUMENTTEMPLATE_SAVE_PROCESSING",
  DOCUMENTTEMPLATE_SAVE_COMPLETE = "@requestor/DOCUMENTTEMPLATE_SAVE_COMPLETE",
  DOCUMENTTEMPLATE_SAVE_ERROR = "@requestor/DOCUMENTTEMPLATE_SAVE_ERROR",
  DOCUMENTTEMPLATE_DELETE_PROCESSING = "@requestor/DOCUMENTTEMPLATE_DELETE_PROCESSING",
  DOCUMENTTEMPLATE_DELETE_COMPLETE = "@requestor/DOCUMENTTEMPLATE_DELETE_COMPLETE",
  DOCUMENTTEMPLATE_DELETE_ERROR = "@requestor/DOCUMENTTEMPLATE_DELETE_ERROR",
  DOCUMENTTEMPLATE_LOAD_PROCESSING = "@requestor/DOCUMENTTEMPLATE_LOAD_PROCESSING",
  DOCUMENTTEMPLATE_LOAD_COMPLETE = "@requestor/DOCUMENTTEMPLATE_LOAD_COMPLETE",
  DOCUMENTTEMPLATE_LOAD_ERROR = "@requestor/DOCUMENTTEMPLATE_LOAD_ERROR",
  DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_PROCESSING = "@requestor/DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_PROCESSING",
  DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_COMPLETE = "@requestor/DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_COMPLETE",
  DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_ERROR = "@requestor/DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_ERROR",
  DOCUMENTTEMPLATE_SIGNATURE_POSITION_PROCESSING = "@requestor/DOCUMENTTEMPLATE_SIGNATURE_POSITION_PROCESSING",
  DOCUMENTTEMPLATE_SIGNATURE_POSITION_COMPLETE = "@requestor/DOCUMENTTEMPLATE_SIGNATURE_POSITION_COMPLETE",
  DOCUMENTTEMPLATE_SIGNATURE_POSITION_ERROR = "@requestor/DOCUMENTTEMPLATE_SIGNATURE_POSITION_ERROR",
  DOCUMENTTEMPLATES_LOAD_PROCESSING = "@requestor/DOCUMENTTEMPLATES_LOAD_PROCESSING",
  DOCUMENTTEMPLATES_LOAD_COMPLETE = "@requestor/DOCUMENTTEMPLATES_LOAD_COMPLETE",
  DOCUMENTTEMPLATES_LOAD_ERROR = "@requestor/DOCUMENTTEMPLATES_LOAD_ERROR",
  PACKAGES_LOAD_PROCESSING = "@requestor/PACKAGES_LOAD_PROCESSING",
  PACKAGES_LOAD_COMPLETE = "@requestor/PACKAGES_LOAD_COMPLETE",
  PACKAGES_LOAD_ERROR = "@requestor/PACKAGES_LOAD_ERROR",
  PACKAGE_SAVE_PROCESSING = "@requestor/PACKAGE_SAVE_PROCESSING",
  PACKAGE_SAVE_COMPLETE = "@requestor/PACKAGE_SAVE_COMPLETE",
  PACKAGE_SAVE_ERROR = "@requestor/PACKAGE_SAVE_ERROR",
  PACKAGE_DELETE_PROCESSING = "@requestor/PACKAGE_DELETE_PROCESSING",
  PACKAGE_DELETE_COMPLETE = "@requestor/PACKAGE_DELETE_COMPLETE",
  PACKAGE_DELETE_ERROR = "@requestor/PACKAGE_DELETE_ERROR",
  SELECTROUTINGS_LOAD_PROCESSING = "@requestor/SELECTROUTINGS_LOAD_PROCESSING",
  SELECTROUTINGS_LOAD_COMPLETE = "@requestor/SELECTROUTINGS_LOAD_COMPLETE",
  SELECTROUTINGS_LOAD_ERROR = "@requestor/SELECTROUTINGS_LOAD_ERROR",
  SELECTROUTING_SAVE_PROCESSING = "@requestor/SELECTROUTING_SAVE_PROCESSING",
  SELECTROUTING_SAVE_COMPLETE = "@requestor/SELECTROUTING_SAVE_COMPLETE",
  SELECTROUTING_SAVE_ERROR = "@requestor/SELECTROUTING_SAVE_ERROR",
  SELECTROUTING_DELETE_PROCESSING = "@requestor/SELECTROUTING_DELETE_PROCESSING",
  SELECTROUTING_DELETE_COMPLETE = "@requestor/SELECTROUTING_DELETE_COMPLETE",
  SELECTROUTING_DELETE_ERROR = "@requestor/SELECTROUTING_DELETE_ERROR",
  SIGNATORYGROUPS_LOAD_PROCESSING = "@requestor/SIGNATORYGROUPS_LOAD_PROCESSING",
  SIGNATORYGROUPS_LOAD_COMPLETE = "@requestor/SIGNATORYGROUPS_LOAD_COMPLETE",
  SIGNATORYGROUPS_LOAD_ERROR = "@requestor/SIGNATORYGROUPS_LOAD_ERROR",
  SIGNATORYGROUP_SAVE_PROCESSING = "@requestor/SIGNATORYGROUP_SAVE_PROCESSING",
  SIGNATORYGROUP_SAVE_COMPLETE = "@requestor/SIGNATORYGROUP_SAVE_COMPLETE",
  SIGNATORYGROUP_SAVE_ERROR = "@requestor/SIGNATORYGROUP_SAVE_ERROR",
  SIGNATORYGROUP_DELETE_PROCESSING = "@requestor/SIGNATORYGROUP_DELETE_PROCESSING",
  SIGNATORYGROUP_DELETE_COMPLETE = "@requestor/SIGNATORYGROUP_DELETE_COMPLETE",
  SIGNATORYGROUP_DELETE_ERROR = "@requestor/SIGNATORYGROUP_DELETE_ERROR",
  MESSAGE_LOAD_PROCESSING = "@requestor/MESSAGE_LOAD_PROCESSING",
  MESSAGE_LOAD_COMPLETE = "@requestor/MESSAGE_LOAD_COMPLETE",
  MESSAGE_LOAD_ERROR = "@requestor/MESSAGE_LOAD_ERROR",
  MESSAGE_SAVE_PROCESSING = "@requestor/MESSAGE_SAVE_PROCESSING",
  MESSAGE_SAVE_COMPLETE = "@requestor/MESSAGE_SAVE_COMPLETE",
  MESSAGE_SAVE_ERROR = "@requestor/MESSAGE_SAVE_ERROR",
  MESSAGES_RESTORE_STATES = "@requestor/MESSAGES_RESTORE_STATES",
  MESSAGES_CLEAN_VALUE = "@requestor/MESSAGES_CLEAN_VALUE",
  MESSAGES_LOAD_PROCESSING = "@requestor/MESSAGES_LOAD_PROCESSING",
  MESSAGES_LOAD_COMPLETE = "@requestor/MESSAGES_LOAD_COMPLETE",
  MESSAGES_LOAD_ERROR = "@requestor/MESSAGES_LOAD_ERROR",
  MESSAGE_DELETE_PROCESSING = "@requestor/MESSAGE_DELETE_PROCESSING",
  MESSAGE_DELETE_COMPLETE = "@requestor/MESSAGE_DELETE_COMPLETE",
  MESSAGE_DELETE_ERROR = "@requestor/MESSAGE_DELETE_ERROR",
  MESSAGE_LOCAL_DELETE = "@requestor/MESSAGE_LOCAL_DELETE",
  MESSAGES_PAGINATION_LOAD_PROCESSING = "@requestor/MESSAGES_PAGINATION_LOAD_PROCESSING",
  MESSAGES_PAGINATION_LOAD_COMPLETE = "@requestor/MESSAGES_PAGINATION_LOAD_COMPLETE",
  MESSAGES_PAGINATION_LOAD_ERROR = "@requestor/MESSAGES_PAGINATION_LOAD_ERROR",
  MESSAGES_COUNT_LOAD_COMPLETE = "@requestor/MESSAGES_COUNT_LOAD_COMPLETE",
  MESSAGES_COUNT_LOAD_ERROR = "@requestor/MESSAGES_COUNT_LOAD_ERROR",
  MESSAGES_COUNT_LOAD_PROCESSING = "@requestor/MESSAGES_COUNT_LOAD_PROCESSING",
  MESSAGE_SEND_PROCESSING = "@requestor/MESSAGE_SEND_PROCESSING",
  MESSAGE_SEND_COMPLETE = "@requestor/MESSAGE_SEND_COMPLETE",
  MESSAGE_SEND_ERROR = "@requestor/MESSAGE_SEND_ERROR",
  MESSAGES_COUNT_CLEAN = "@requestor/MESSAGES_COUNT_CLEAN",
  EXTERNALSCHOOLINTEGRATION_SECTIONS_RESTORE_STATES = "@requestor/EXTERNALSCHOOLINTEGRATION_SECTIONS_RESTORE_STATES",
  EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_PROCESSING = "@requestor/EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_PROCESSING",
  EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_COMPLETE = "@requestor/EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_COMPLETE",
  EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_ERROR = "@requestor/EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_ERROR",
  EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_PROCESSING = "@requestor/EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_PROCESSING",
  EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_COMPLETE = "@requestor/EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_COMPLETE",
  EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_ERROR = "@requestor/EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_ERROR",
  EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_PROCESSING = "@requestor/EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_PROCESSING",
  EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_COMPLETE = "@requestor/EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_COMPLETE",
  EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_ERROR = "@requestor/EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_ERROR",
  EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_PROCESSING = "@requestor/EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_PROCESSING",
  EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_COMPLETE = "@requestor/EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_COMPLETE",
  EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_ERROR = "@requestor/EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_ERROR",
  EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_PROCESSING = "@requestor/EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_PROCESSING",
  EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_COMPLETE = "@requestor/EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_COMPLETE",
  EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_ERROR = "@requestor/EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_ERROR",
  CAMPAING_GET_SIGNINGDOCUMENTS_PROCESSING = "@requestor/CAMPAING_GET_SIGNINGDOCUMENTS_PROCESSING",
  CAMPAING_GET_SIGNINGDOCUMENTS_COMPLETE = "@requestor/CAMPAING_GET_SIGNINGDOCUMENTS_COMPLETE",
  CAMPAING_GET_SIGNINGDOCUMENTS_ERROR = "@requestor/CAMPAING_GET_SIGNINGDOCUMENTS_ERROR",
  CAMPAIGN_EMAIL_TRACKING_PROCESSING = "@requestor/CAMPAIGN_EMAIL_TRACKING_PROCESSING",
  CAMPAIGN_EMAIL_TRACKING_COMPLETE = "@requestor/CAMPAIGN_EMAIL_TRACKING_COMPLETE",
  CAMPAIGN_EMAIL_TRACKING_ERROR = "@requestor/CAMPAIGN_EMAIL_TRACKING_ERROR",
  CHART_CAMPAIGNS_PROCESSING = "@requestor/CHART_CAMPAIGNS_PROCESSING",
  CHART_CAMPAIGNS_COMPLETE = "@requestor/CHART_CAMPAIGNS_COMPLETE",
  CHART_CAMPAIGNS_ERROR = "@requestor/CHART_CAMPAIGNS_ERROR",
  POSTGIS_CLEAN_VALUES = "@requestor/POSTGIS_CLEAN_VALUES",
  POSTGIS_SCHOOLS_LOAD_PROCESSING = "@requestor/POSTGIS_SCHOOLS_LOAD_PROCESSING",
  POSTGIS_SCHOOLS_LOAD_COMPLETE = "@requestor/POSTGIS_SCHOOLS_LOAD_COMPLETE",
  POSTGIS_SCHOOLS_LOAD_ERROR = "@requestor/POSTGIS_SCHOOLS_LOAD_ERROR",
  POSTGIS_GRADES_LOAD_PROCESSING = "@requestor/POSTGIS_GRADES_LOAD_PROCESSING",
  POSTGIS_GRADES_LOAD_COMPLETE = "@requestor/POSTGIS_GRADES_LOAD_COMPLETE",
  POSTGIS_GRADES_LOAD_ERROR = "@requestor/POSTGIS_GRADES_LOAD_ERROR",
  POSTGIS_PROGRAMS_LOAD_PROCESSING = "@requestor/POSTGIS_PROGRAMS_LOAD_PROCESSING",
  POSTGIS_PROGRAMS_LOAD_COMPLETE = "@requestor/POSTGIS_PROGRAMS_LOAD_COMPLETE",
  POSTGIS_PROGRAMS_LOAD_ERROR = "@requestor/POSTGIS_PROGRAMS_LOAD_ERROR",
  POSTGIS_ASSIGNMENTS_LOAD_PROCESSING = "@requestor/POSTGIS_ASSIGNMENTS_LOAD_PROCESSING",
  POSTGIS_ASSIGNMENTS_LOAD_COMPLETE = "@requestor/POSTGIS_ASSIGNMENTS_LOAD_COMPLETE",
  POSTGIS_ASSIGNMENTS_LOAD_ERROR = "@requestor/POSTGIS_ASSIGNMENTS_LOAD_ERROR",
  POSTGIS_STUDENTS_CLEAN_VALUE = "@requestor/POSTGIS_STUDENTS_CLEAN_VALUE",
  POSTGIS_STUDENTS_LOAD_PROCESSING = "@requestor/POSTGIS_STUDENTS_LOAD_PROCESSING",
  POSTGIS_STUDENTS_LOAD_COMPLETE = "@requestor/POSTGIS_STUDENTS_LOAD_COMPLETE",
  POSTGIS_STUDENTS_LOAD_ERROR = "@requestor/POSTGIS_STUDENTS_LOAD_ERROR",
  POSTGIS_STUDENTS_NUMBER_LOAD_PROCESSING = "@requestor/POSTGIS_STUDENTS_NUMBER_LOAD_PROCESSING",
  POSTGIS_STUDENTS_NUMBER_LOAD_COMPLETE = "@requestor/POSTGIS_STUDENTS_NUMBER_LOAD_COMPLETE",
  POSTGIS_STUDENTS_NUMBER_LOAD_ERROR = "@requestor/POSTGIS_STUDENTS_NUMBER_LOAD_ERROR",
  STUDENTS_BY_SCHOOL_LOAD_PROCESSING = "@requestor/STUDENTS_BY_SCHOOL_LOAD_PROCESSING",
  STUDENTS_BY_SCHOOL_LOAD_COMPLETE = "@requestor/STUDENTS_BY_SCHOOL_LOAD_COMPLETE",
  STUDENTS_BY_SCHOOL_LOAD_ERROR = "@requestor/STUDENTS_BY_SCHOOL_LOAD_ERROR",
  PROGRAM_DEMAND_LOAD_PROCESSING = "@requestor/PROGRAM_DEMAND_LOAD_PROCESSING",
  PROGRAM_DEMAND_LOAD_COMPLETE = "@requestor/PROGRAM_DEMAND_LOAD_COMPLETE",
  PROGRAM_DEMAND_LOAD_ERROR = "@requestor/PROGRAM_DEMAND_LOAD_ERROR",
  CHOICE_DASHBOARD_LOAD_PROCESSING = "@requestor/CHOICE_DASHBOARD_LOAD_PROCESSING",
  CHOICE_DASHBOARD_LOAD_COMPLETE = "@requestor/CHOICE_DASHBOARD_LOAD_COMPLETE",
  CHOICE_DASHBOARD_LOAD_ERROR = "@requestor/CHOICE_DASHBOARD_LOAD_ERROR",
  CHOICE_DASHBOARD_RESET = "@requestor/CHOICE_DASHBOARD_RESET",
  PROJECTED_ENROLLMENT_LOAD_PROCESSING = "@requestor/PROJECTED_ENROLLMENT_LOAD_PROCESSING",
  PROJECTED_ENROLLMENT_LOAD_COMPLETE = "@requestor/PROJECTED_ENROLLMENT_LOAD_COMPLETE",
  PROJECTED_ENROLLMENT_LOAD_ERROR = "@requestor/PROJECTED_ENROLLMENT_LOAD_ERROR",
  LASTVALUEKEY_CLEAN = "@requestor/LASTVALUEKEY_CLEAN",
}

export const restoreCampaign = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_RESTORE_STATES });
  };
};

export const cleanCampaign = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.CAMPAIGN_CLEAN_VALUE });
  };
};

export const cleanCampaigns = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_CLEAN_VALUE });
  };
};

export const cleanLastValueKey = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.LASTVALUEKEY_CLEAN });
  };
};

export const cleanCampaignsCount = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_COUNT_CLEAN });
  };
};

export const saveCampaign = (user: User, campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_SAVE_COMPLETE,
        payload: await deps.requestorInteractor.saveCampaign(user, campaign),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGN_SAVE_ERROR, payload: error });
    }
  };
};

export const deleteCampaign = (
  user: User,
  campaign: Campaign,
  targetAudience: TargetAudience
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_DELETE_COMPLETE,
        payload: await deps.requestorInteractor.deleteCampaign(
          user,
          campaign,
          targetAudience
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGN_DELETE_ERROR, payload: error });
    }
  };
};

export const deleteLocalCampaign = (campaignId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.CAMPAIGN_LOCAL_DELETE,
      payload: campaignId,
    });
  };
};

export const sendCampaign = (user: User, campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_SEND_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_SEND_COMPLETE,
        payload: await deps.requestorInteractor.sendCampaign(user, campaign),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGN_SEND_ERROR, payload: error });
    }
  };
};

export const sendDocumentIndividual = (formData: SendDocFormInputs) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_SEND_INDIVIDUAL_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_SEND_INDIVIDUAL_COMPLETE,
        payload: await deps.requestorInteractor.sendDocumentIndividual(
          formData
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGN_SEND_INDIVIDUAL_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCampaign = (user: User, campaignId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCampaign(user, campaignId),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGN_LOAD_ERROR, payload: error });
    }
  };
};

export const loadCampaignExternal = (shortId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCampaignExt(shortId),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGN_LOAD_ERROR, payload: error });
    }
  };
};

export const loadCampaigns = (user: User, targetAudience: TargetAudience) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGNS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCampaigns(
          user,
          targetAudience
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGNS_LOAD_ERROR, payload: error });
    }
  };
};

export const loadCampaignsPagination = (
  user: User,
  targetAudience: TargetAudience,
  pageSize: number
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const { lastEvaluatedKey } = getState().requestor;

    dispatch({ type: ActionTypes.CAMPAIGNS_PAGINATION_LOAD_PROCESSING });
    try {
      const response = await deps.requestorInteractor.getCampaignsPagination(
        user,
        targetAudience,
        pageSize,
        lastEvaluatedKey
      );

      dispatch({
        type: ActionTypes.CAMPAIGNS_PAGINATION_LOAD_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGNS_PAGINATION_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCampaignsbyLookup = (
  user: User,
  targetAudience: TargetAudience,
  lookupType: string,
  lookupValue: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGNS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCampaignsbyLookup(
          user,
          targetAudience,
          lookupType,
          lookupValue
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGNS_LOAD_ERROR, payload: error });
    }
  };
};

export const loadCampaignsByLookupPagination = (
  user: User,
  targetAudience: TargetAudience,
  lookupType: string,
  lookupValue: string,
  pageSize: number
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const { lastEvaluatedKey, campaigns } = getState().requestor;

    const existingCampaignIds =
      campaigns?.length > 0 ? campaigns.map((c: Campaign) => c.id) : undefined;

    dispatch({ type: ActionTypes.CAMPAIGNS_PAGINATION_LOAD_PROCESSING });
    try {
      const response =
        await deps.requestorInteractor.getCampaignsByLookupPagination(
          user,
          targetAudience,
          lookupType,
          lookupValue,
          pageSize,
          lastEvaluatedKey,
          existingCampaignIds
        );

      dispatch({
        type: ActionTypes.CAMPAIGNS_PAGINATION_LOAD_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGNS_PAGINATION_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadAllCampaigns = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGNS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getAllCampaigns(user),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGNS_LOAD_ERROR, payload: error });
    }
  };
};

export const loadCampaignsCount = (
  user: User,
  targetAudience: TargetAudience
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_COUNT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGNS_COUNT_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCampaignsCount(
          user,
          targetAudience
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGNS_COUNT_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCampaignsLookupsCount = (
  user: User,
  targetAudience: TargetAudience,
  lookupType: string,
  lookupValue: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGNS_COUNT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGNS_COUNT_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCampaignsLookupsCount(
          user,
          targetAudience,
          lookupType,
          lookupValue
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGNS_COUNT_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const getSigningDocument = (user: User, campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAING_GET_SIGNINGDOCUMENTS_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAING_GET_SIGNINGDOCUMENTS_COMPLETE,
        payload: await deps.requestorInteractor.getSigningDocument(
          user,
          campaign
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAING_GET_SIGNINGDOCUMENTS_ERROR,
        payload: error,
      });
    }
  };
};

export const getCampaignEmailTracking = (user: User, campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_EMAIL_TRACKING_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_EMAIL_TRACKING_COMPLETE,
        payload: await deps.requestorInteractor.getCampaignEmailTracking(
          user,
          campaign
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGN_EMAIL_TRACKING_ERROR,
        payload: error,
      });
    }
  };
};

export const getMessageEmailTracking = (user: User, message: Message) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_EMAIL_TRACKING_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_EMAIL_TRACKING_COMPLETE,
        payload: await deps.requestorInteractor.getMessageEmailTracking(
          user,
          message
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CAMPAIGN_EMAIL_TRACKING_ERROR,
        payload: error,
      });
    }
  };
};

export const clearDocumentStaff = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.CLEAR_DOCUMENT_STAFF });
  };
}

export const processDocumentStaffbyCampaign = (campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENT_STAFF_PROCESS_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENT_STAFF_PROCESS_COMPLETE,
        payload: await deps.requestorInteractor.processDocumentStaffbyCampaign(campaign),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.DOCUMENT_STAFF_PROCESS_ERROR, payload: error });
    }
  };
};

export const saveDocumentTemplate = (
  user: User,
  documentTemplate: DocumentTemplate
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENTTEMPLATE_SAVE_PROCESSING });
    try {
      const response = await deps.requestorInteractor.saveDocumentTemplate(
        user,
        documentTemplate
      );
      documentTemplate.id = response.id;
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_SAVE_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_SAVE_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteDocumentTemplate = (
  user: User,
  documentTemplate: DocumentTemplate
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENTTEMPLATE_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_DELETE_COMPLETE,
        payload: await deps.requestorInteractor.deleteDocumentTemplate(
          user,
          documentTemplate
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_DELETE_ERROR,
        payload: error,
      });
    }
  };
};

export const loadDocumentTemplate = (
  user: User,
  documentTemplateId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENTTEMPLATE_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getDocumentTemplate(
          user,
          documentTemplateId
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadDocTemplateByCampaign = (
  userId: string,
  organizationId: string,
  campaignId: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.loadDocTemplateByCampaign(
          userId,
          organizationId,
          campaignId
        ),
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_BY_CAMPAIGN_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const saveDocumentTemplateSignaturePosition = (
  user: User,
  documentTemplate: DocumentTemplate,
  file: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.DOCUMENTTEMPLATE_SIGNATURE_POSITION_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_SIGNATURE_POSITION_COMPLETE,
        payload:
          await deps.requestorInteractor.documentTemplateSignaturePosition(
            user,
            documentTemplate,
            file
          ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATE_SIGNATURE_POSITION_ERROR,
        payload: error,
      });
    }
  };
};

export const loadDocumentTemplates = (
  user: User,
  documentPackage?: Package,
  includeFiles?: boolean
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.DOCUMENTTEMPLATES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getDocumentTemplates(
          user,
          documentPackage,
          includeFiles
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.DOCUMENTTEMPLATES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadPackages = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PACKAGES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PACKAGES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getPackages(user),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PACKAGES_LOAD_ERROR, payload: error });
    }
  };
};

export const savePackage = (user: User, objPackage: Package) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PACKAGE_SAVE_PROCESSING });
    try {
      const response = await deps.requestorInteractor.savePackage(
        user,
        objPackage
      );
      objPackage.id = response.id;
      dispatch({
        type: ActionTypes.PACKAGE_SAVE_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PACKAGE_SAVE_ERROR, payload: error });
    }
  };
};

export const deletePackage = (user: User, objPackage: Package) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.PACKAGE_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.PACKAGE_DELETE_COMPLETE,
        payload: await deps.requestorInteractor.deletePackage(user, objPackage),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.PACKAGE_DELETE_ERROR, payload: error });
    }
  };
};

export const loadSignatoryGroups = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORYGROUPS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SIGNATORYGROUPS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getSignatoryGroups(user),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SIGNATORYGROUPS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const saveSignatoryGroup = (
  user: User,
  signatoryGroup: SignatoryGroup
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORYGROUP_SAVE_PROCESSING });
    try {
      const response = await deps.requestorInteractor.saveSignatoryGroup(
        user,
        signatoryGroup
      );
      signatoryGroup.id = response.id;
      dispatch({
        type: ActionTypes.SIGNATORYGROUP_SAVE_COMPLETE,
        payload: response,
      });
      // Reload the list immediately after a successful save
      (dispatch as any)(loadSignatoryGroups(user));
      return true;
    } catch (error) {
      dispatch({ type: ActionTypes.SIGNATORYGROUP_SAVE_ERROR, payload: error });
      return false;
    }
  };
};

export const saveSignatoryGroupAsync = (
  user: User,
  signatoryGroup: SignatoryGroup
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORYGROUP_SAVE_PROCESSING });
    try {
      const response = await deps.requestorInteractor.saveSignatoryGroupAsync(
        user,
        signatoryGroup
      );
      dispatch({
        type: ActionTypes.SIGNATORYGROUP_SAVE_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SIGNATORYGROUP_SAVE_ERROR, payload: error });
    }
  };
};

export const deleteSignatoryGroup = (
  user: User,
  signatoryGroup: SignatoryGroup
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SIGNATORYGROUP_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SIGNATORYGROUP_DELETE_COMPLETE,
        payload: await deps.requestorInteractor.deleteSignatoryGroup(
          user,
          signatoryGroup
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SIGNATORYGROUP_DELETE_ERROR,
        payload: error,
      });
    }
  };
};

export const restoreMessage = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.MESSAGES_RESTORE_STATES });
  };
};

export const cleanMessages = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.MESSAGES_CLEAN_VALUE });
  };
};

export const cleanMessagesCount = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.MESSAGES_COUNT_CLEAN });
  };
};

export const saveMessage = (user: User, message: Message) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGE_SAVE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGE_SAVE_COMPLETE,
        payload: await deps.requestorInteractor.saveMessage(user, message),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGE_SAVE_ERROR, payload: error });
    }
  };
};

export const loadMessage = (user: User, messageId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGE_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGE_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getMessage(user, messageId),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGE_LOAD_ERROR, payload: error });
    }
  };
};

export const loadMessages = (user: User, targetAudience: TargetAudience) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getMessages(
          user,
          targetAudience
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGES_LOAD_ERROR, payload: error });
    }
  };
};

export const loadMessagesPagination = (
  user: User,
  targetAudience: TargetAudience,
  pageSize: number
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const { lastEvaluatedKey } = getState().requestor;

    dispatch({ type: ActionTypes.MESSAGES_PAGINATION_LOAD_PROCESSING });
    try {
      const response = await deps.requestorInteractor.getMessagesPagination(
        user,
        targetAudience,
        pageSize,
        lastEvaluatedKey
      );

      dispatch({
        type: ActionTypes.MESSAGES_PAGINATION_LOAD_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.MESSAGES_PAGINATION_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadMessagesbyLookup = (
  user: User,
  targetAudience: TargetAudience,
  lookupType: string,
  lookupValue: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getMessagesbyLookup(
          user,
          targetAudience,
          lookupType,
          lookupValue
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGES_LOAD_ERROR, payload: error });
    }
  };
};

export const loadMessagesByLookupPagination = (
  user: User,
  targetAudience: TargetAudience,
  lookupType: string,
  lookupValue: string,
  pageSize: number
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const { lastEvaluatedKey, messages } = getState().requestor;

    const existingMessageIds =
      messages?.length > 0 ? messages.map((m: Message) => m.id) : undefined;

    dispatch({ type: ActionTypes.MESSAGES_PAGINATION_LOAD_PROCESSING });
    try {
      const response =
        await deps.requestorInteractor.getMessagesByLookupPagination(
          user,
          targetAudience,
          lookupType,
          lookupValue,
          pageSize,
          lastEvaluatedKey,
          existingMessageIds
        );

      dispatch({
        type: ActionTypes.MESSAGES_PAGINATION_LOAD_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.MESSAGES_PAGINATION_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadMessagesBySignatory = (user: User, signatoryEmail: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGES_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getMessagesBySignatory(
          user,
          signatoryEmail
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGES_LOAD_ERROR, payload: error });
    }
  };
};

export const deleteMessage = (
  user: User,
  message: Message,
  targetAudience: TargetAudience
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGE_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGE_DELETE_COMPLETE,
        payload: await deps.requestorInteractor.deleteMessage(
          user,
          message,
          targetAudience
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGE_DELETE_ERROR, payload: error });
    }
  };
};

export const deleteLocalMessage = (messageId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.MESSAGE_LOCAL_DELETE,
      payload: messageId,
    });
  };
};

export const sendMessage = (user: User, message: Message) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGE_SEND_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGE_SEND_COMPLETE,
        payload: await deps.requestorInteractor.sendMessage(user, message),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGE_SEND_ERROR, payload: error });
    }
  };
};

export const loadMessagesCount = (
  user: User,
  targetAudience: TargetAudience
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGES_COUNT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGES_COUNT_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getMessagesCount(
          user,
          targetAudience
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGES_COUNT_LOAD_ERROR, payload: error });
    }
  };
};

export const loadMessagesLookupsCount = (
  user: User,
  targetAudience: TargetAudience,
  lookupType: string,
  lookupValue: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.MESSAGES_COUNT_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.MESSAGES_COUNT_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getMessagesLookupsCount(
          user,
          targetAudience,
          lookupType,
          lookupValue
        ),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.MESSAGES_COUNT_LOAD_ERROR, payload: error });
    }
  };
};

export const restoreSections = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SECTIONS_RESTORE_STATES,
    });
  };
};

export const loadGrades = (
  organization: Organization,
  schoolYearStart: number,
  schoolYearEnd: number
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getGrades(
          organization,
          schoolYearStart,
          schoolYearEnd
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_GRADES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadSections = (cleverToken: string, schoolId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getSections(
          cleverToken,
          schoolId
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SECTIONS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadStudents = (
  organization: Organization,
  schoolYearStart: number,
  schoolYearEnd: number,
  grade: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getStudents(
          organization,
          schoolYearStart,
          schoolYearEnd,
          grade
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_STUDENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadStudentSignatories = (
  organization: Organization,
  schoolYearStart: number,
  schoolYearEnd: number,
  grade: string,
  student: Student
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getStudentSignatories(
          organization,
          schoolYearStart,
          schoolYearEnd,
          grade,
          student
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_STUDENTSIGNATORIES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadSignatories = (
  organization: Organization,
  schoolYearStart: number,
  schoolYearEnd: number,
  grade: string
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getSignatories(
          organization,
          schoolYearStart,
          schoolYearEnd,
          grade
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.EXTERNALSCHOOLINTEGRATION_SIGNATORIES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCampaignChart = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CHART_CAMPAIGNS_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CHART_CAMPAIGNS_COMPLETE,
        payload: await deps.requestorInteractor.getCampaignChart(user),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CHART_CAMPAIGNS_ERROR, payload: error });
    }
  };
};

export const saveSendCampaign = (user: User, campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.CAMPAIGN_SAVE_SEND_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.CAMPAIGN_SAVE_SEND_COMPLETE,
        payload: await deps.requestorInteractor.saveSendCampaign(user, campaign),
      });
    } catch (error) {
      dispatch({ type: ActionTypes.CAMPAIGN_SAVE_SEND_ERROR, payload: error });
    }
  };
};

export const saveSelectRouting = (
  user: User,
  selectRouting: SelectRouting
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SELECTROUTING_SAVE_PROCESSING });
    try {
      const response = await deps.requestorInteractor.saveSelectRouting(
        user,
        selectRouting
      );
      selectRouting.id = response.id;
      dispatch({
        type: ActionTypes.SELECTROUTING_SAVE_COMPLETE,
        payload: response,
      });
    } catch (error) {
      dispatch({ type: ActionTypes.SELECTROUTING_SAVE_ERROR, payload: error });
    }
  };
};

export const deleteSelectRouting = (
  user: User,
  selectRouting: SelectRouting
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SELECTROUTING_DELETE_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SELECTROUTING_DELETE_COMPLETE,
        payload: await deps.requestorInteractor.deleteSelectRouting(
          user,
          selectRouting
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SELECTROUTING_DELETE_ERROR,
        payload: error,
      });
    }
  };
};

export const loadSelectRoutings = (user: User) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({ type: ActionTypes.SELECTROUTINGS_LOAD_PROCESSING });
    try {
      dispatch({
        type: ActionTypes.SELECTROUTINGS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getSelectRoutings(user),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.SELECTROUTINGS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const cleanPostgis = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.POSTGIS_CLEAN_VALUES });
  };
};

export const loadSchoolsZone = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_SCHOOLS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_SCHOOLS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getSchoolsZone(organizationId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_SCHOOLS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadGradesZone = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_GRADES_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_GRADES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getGradesZone(organizationId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_GRADES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadGradesZoneFiltered = (
  organizationId: string,
  zoneFilter: ZoneFilter,
  schoolIds: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_GRADES_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_GRADES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getGradesZoneFiltered(
          organizationId,
          zoneFilter,
          schoolIds
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_GRADES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadProgramsZone = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_PROGRAMS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_PROGRAMS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getProgramsZone(organizationId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_PROGRAMS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadAssignmentsZone = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getAssignmentsZone(organizationId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadProgramsZoneFiltered = (
  organizationId: string,
  zoneFilter: ZoneFilter,
  schoolIds: string[],
  grades: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_PROGRAMS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_PROGRAMS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getProgramsZoneFiltered(
          organizationId,
          zoneFilter,
          schoolIds,
          grades
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_PROGRAMS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadAssignmentsZoneFiltered = (
  organizationId: string,
  zoneFilter: ZoneFilter,
  schoolIds: string[],
  grades: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getAssignmentsZoneFiltered(
          organizationId,
          zoneFilter,
          schoolIds,
          grades
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadGradesBySchools = (organizationId: string, schoolIds: string[]) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_GRADES_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_GRADES_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getGradesBySchools(organizationId, schoolIds),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_GRADES_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadProgramsBySchools = (
  organizationId: string,
  schoolIds: string[],
  grades: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_PROGRAMS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_PROGRAMS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getProgramsBySchools(
          organizationId,
          schoolIds,
          grades
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_PROGRAMS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadAssignmentsBySchools = (
  organizationId: string,
  schoolIds: string[],
  grades: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getAssignmentsBySchools(
          organizationId,
          schoolIds,
          grades
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_ASSIGNMENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const cleanPostgisStudents = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ActionTypes.POSTGIS_STUDENTS_CLEAN_VALUE });
  };
};

export const loadPostgisStudentsZone = (
  organizationId: string,
  zoneFilter: ZoneFilter,
  schoolIds: string[],
  grades: string[],
  programs: string[],
  assignments: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_STUDENTS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getPostgisStudentsZone(
          organizationId,
          zoneFilter,
          schoolIds,
          grades,
          programs,
          assignments
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadPostgisStudentsByFilters = (
  organizationId: string,
  schoolIds: string[],
  grades: string[],
  programs: string[]
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_STUDENTS_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getPostgisStudentsByFilters(
          organizationId,
          schoolIds,
          grades,
          programs
        ),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadArchiveDates = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    try {
      const dates = await deps.requestorInteractor.getArchiveDates(organizationId);
      return dates;
    } catch (error) {
      console.error("Error loading archive dates:", error);
      return [];
    }
  };
};

export const loadArchivedStudentNumberForGradesAndPrograms = (organizationId: string, archiveDate: string, schoolId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getArchivedStudentNumberForGradesAndPrograms(organizationId, archiveDate, schoolId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCompareStudentsCountByGradeAndProgram = (organizationId: string, archiveDate1: string, archiveDate2: string, schoolId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCompareStudentsCountByGradeAndProgram(organizationId, archiveDate1, archiveDate2, schoolId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadArchivedStudentNumberForGradesAndProgramsAllSchools = (organizationId: string, archiveDate: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getArchivedStudentNumberForGradesAndProgramsAllSchools(organizationId, archiveDate),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCompareStudentsCountByGradeAndProgramAllSchools = (organizationId: string, archiveDate1: string, archiveDate2: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCompareStudentsCountByGradeAndProgramAllSchools(organizationId, archiveDate1, archiveDate2),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.POSTGIS_STUDENTS_NUMBER_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadStudentsCountBySchoolGradeAndProgram = (organizationId: string, archiveDate: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const cached = getState().requestor.studentsBySchool;
    if (archiveDate !== "current" && cached && cached[archiveDate]) {
      return;
    }
    dispatch({
      type: ActionTypes.STUDENTS_BY_SCHOOL_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.STUDENTS_BY_SCHOOL_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getStudentsCountBySchoolGradeAndProgram(organizationId, archiveDate),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.STUDENTS_BY_SCHOOL_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadProgramDemand = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.PROGRAM_DEMAND_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.PROGRAM_DEMAND_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getProgramDemand(organizationId),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.PROGRAM_DEMAND_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

/** Monotonic id per dashboard request, so a slow response for an earlier filter cannot overwrite a newer one. */
let choiceDashboardRequestSeq = 0;

export const loadChoiceDashboard = (organizationId: string, filters: ChoiceDashboardFilters) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const requestId = ++choiceDashboardRequestSeq;
    dispatch({
      type: ActionTypes.CHOICE_DASHBOARD_LOAD_PROCESSING,
      requestId,
    });
    try {
      dispatch({
        type: ActionTypes.CHOICE_DASHBOARD_LOAD_COMPLETE,
        // Data Privacy Mode: real school filter out, masked payload in (choicePrivacy).
        payload: maskChoicePayload(await deps.requestorInteractor.getChoiceDashboard(organizationId, unmaskChoiceFilters(filters))),
        requestId,
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.CHOICE_DASHBOARD_LOAD_ERROR,
        payload: error,
        requestId,
      });
    }
  };
};

/** Forgets the previous visit's dashboard payload so a revisit shows a spinner, not stale numbers under fresh filters. */
export const resetChoiceDashboard = () => ({ type: ActionTypes.CHOICE_DASHBOARD_RESET });

/** The org's school years in the Choice data, unfiltered; returned directly, not kept in the store. */
export const loadChoiceYears = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return deps.requestorInteractor.getChoiceYears(organizationId);
  };
};

/** One page of the Choice applications table; returned directly, not kept in the store. */
export const loadChoiceRows = (organizationId: string, request: ChoiceRowsRequest) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return maskChoiceRowsPage(await deps.requestorInteractor.getChoiceRows(organizationId, unmaskChoiceFilters(request)));
  };
};

/** The filtered Choice applications as CSV text. */
export const exportChoiceRows = (organizationId: string, filters: ChoiceDashboardFilters) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const result = await deps.requestorInteractor.exportChoiceRows(organizationId, unmaskChoiceFilters(filters));
    return result && typeof result.csv === "string" ? { ...result, csv: maskChoiceCsv(result.csv) } : result;
  };
};

/** Starts the org's Choice import; resolves with the backend's {status, source} or throws its error message. */
export const startChoiceImport = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return deps.requestorInteractor.startChoiceImport(organizationId);
  };
};

export const loadChoiceImportStatus = (organizationId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return maskChoicePayload(await deps.requestorInteractor.getChoiceImportStatus(organizationId));
  };
};

export const loadProgramApplicants = (organizationId: string, program: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return deps.requestorInteractor.getProgramApplicants(organizationId, program);
  };
};

export const loadExitingStudents = (organizationId: string, school: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return deps.requestorInteractor.getExitingStudents(organizationId, school);
  };
};

export const loadProjectedEnrollment = (organizationId: string, archiveDate: string, years: number, growthRate?: number) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    dispatch({
      type: ActionTypes.PROJECTED_ENROLLMENT_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.PROJECTED_ENROLLMENT_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getProjectedEnrollment(organizationId, archiveDate, years, growthRate),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.PROJECTED_ENROLLMENT_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadCompareStudentsCountBySchoolGradeAndProgram = (organizationId: string, archiveDate1: string, archiveDate2: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const cached = getState().requestor.studentsBySchool;
    const d1Cached = archiveDate1 !== "current" && cached && cached[archiveDate1];
    const d2Cached = archiveDate2 !== "current" && cached && cached[archiveDate2];
    if (d1Cached && d2Cached) {
      return;
    }
    dispatch({
      type: ActionTypes.STUDENTS_BY_SCHOOL_LOAD_PROCESSING,
    });
    try {
      dispatch({
        type: ActionTypes.STUDENTS_BY_SCHOOL_LOAD_COMPLETE,
        payload: await deps.requestorInteractor.getCompareStudentsCountBySchoolGradeAndProgram(organizationId, archiveDate1, archiveDate2),
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.STUDENTS_BY_SCHOOL_LOAD_ERROR,
        payload: error,
      });
    }
  };
};

export const loadSESBreakdownBySchool = (organizationId: string, archiveDate: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    try {
      return await deps.requestorInteractor.getSESBreakdownBySchool(organizationId, archiveDate);
    } catch (error) {
      console.error("Error loading SES breakdown:", error);
      return [];
    }
  };
};

export const loadSESBreakdownByZone = (organizationId: string, zoneFilter: any) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    try {
      return await deps.requestorInteractor.getSESBreakdownByZone(organizationId, zoneFilter);
    } catch (error) {
      console.error("Error loading zone SES breakdown:", error);
      return [];
    }
  };
};

export const fetchStudentsCountByZone = (organizationId: string, zoneFilter: ZoneFilter) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getStudentsCountByZone(organizationId, zoneFilter);
  };
};

export const fetchSeatingStudentDetails = (
  organizationId: string,
  payload: { archiveDate?: string; schoolIds?: string[]; grades?: string[]; programs?: string[]; zoneFilter?: ZoneFilter | null; offset?: number; limit?: number }
) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    const rows = await deps.requestorInteractor.getSeatingStudentDetails(organizationId, payload);
    return isMaskedHere() && Array.isArray(rows) ? rows.map(maskStudentDetail) : rows;
  };
};

export const askZoneAI = (organizationId: string, payload: any) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.askZoneAI(organizationId, payload);
  };
};

export const summarizeZoneAI = (organizationId: string, payload: any) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.summarizeZoneAI(organizationId, payload);
  };
};

export const geocodeAddress = (organizationId: string, payload: { address: string }) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.geocodeAddress(organizationId, payload);
  };
};

export const combineZones = (organizationId: string, payload: { zoneNames: string[]; operation: string }) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.combineZones(organizationId, payload);
  };
};

export const bufferZone = (organizationId: string, payload: { zoneName: string; distance: number; unit: string }) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.bufferZone(organizationId, payload);
  };
};

export const scaleZone = (organizationId: string, payload: { zoneName: string; percentage: number }) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.scaleZone(organizationId, payload);
  };
};

export const translateText = (text: string, targetLanguage: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.translateText(text, targetLanguage);
  };
};

export const fetchSigningDocument = (user: User, campaign: Campaign) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getSigningDocument(user, campaign);
  };
};

export const fetchCleverSchools = (cleverToken: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getCleverSchools(cleverToken);
  };
};

export const fetchCleverStaff = (cleverToken: string, schoolId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getCleverStaff(cleverToken, schoolId);
  };
};

export const fetchCleverStudent = (cleverToken: string, studentId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getCleverStudent(cleverToken, studentId);
  };
};

export const fetchCleverContacts = (cleverToken: string, studentId: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getCleverContacts(cleverToken, studentId);
  };
};

export const fetchCleverToken = (code: string, clientId: string, redirectURI: string) => {
  return async (
    dispatch: Dispatch,
    getState: () => RootState,
    deps: { requestorInteractor: RequestorInteractor }
  ) => {
    return await deps.requestorInteractor.getCleverToken(code, clientId, redirectURI);
  };
};
